import { useQuery } from '@tanstack/react-query';
import { getProviderTrainings } from '@uplift/api';

import { providerQueryKeys } from './providerQueryKeys';
import { BaseQueryOpts } from '../baseTypes';

export const useProviderTrainingsQuery = (providerId: string, opts?: BaseQueryOpts & { requiredOnly?: boolean }) => {
  const { requiredOnly, ...queryOpts } = opts ?? {};

  return useQuery({
    queryKey: providerQueryKeys.trainings(providerId, { requiredOnly }),
    staleTime: 60000,
    refetchOnWindowFocus: true,
    enabled: Boolean(providerId),
    queryFn: async () => {
      const trainings = await getProviderTrainings(providerId, { requiredOnly });

      return trainings.data;
    },
    ...queryOpts,
  });
};
